export const getStringFilterOptionValue = (option: unknown) => {
  return option as string;
};
